// Wire types of api-v2's feature flag routes, written by hand until the API
// publishes them in @handly-app/schemas. Then this file re-exports from there.
export type FeatureFlagKey = string

// Same list and same ORDER as FEATURE_FLAG_AUDIENCES in api-v2. A flag at one
// tier is on for that tier's group and for the groups of all earlier tiers.
export const FEATURE_FLAG_AUDIENCES = [
  'OFF',
  'DEV_OR_LOCAL',
  'SUPPORT',
  'INTERNAL_COMPANIES',
  'POWERDECKER',
  'WHITELIST',
  'EVERYONE',
] as const
export type FeatureFlagAudience = (typeof FEATURE_FLAG_AUDIENCES)[number]

export interface CreateFeatureFlagRequest {
  key: string
  name: string
  description?: string
}

export interface FeatureFlagRule {
  audience: FeatureFlagAudience
  /** Company ids. Stored at every tier, read at WHITELIST and above. */
  whitelist: number[]
}
export interface FeatureFlagDTO extends FeatureFlagRule {
  key: FeatureFlagKey
  name: string
  description: string
  companies?: { id: number; name: string }[]
}
// The API sends only the flags that are on. A missing key reads as off.
export type ResolvedFeatureFlags = Record<FeatureFlagKey, boolean>
